/**
 * Gonka uses BIP44 CoinType 1200, not the generic Cosmos 118.
 * Every Cosmos library defaults to 118. If you do not override this, your
 * addresses will NOT match `inferenced keys add --recover` output for the
 * same mnemonic. This is the single most common Gonka integration mistake.
 */
export const GONKA_COIN_TYPE = 1200;
export const GONKA_HD_PATH = "m/44'/1200'/0'/0/0";
export const GONKA_BECH32_PREFIX = 'gonka';
/**
 * ngonka is the base denom. 1 GNK = 10^9 ngonka.
 * Most Cosmos chains use 10^6 (u-prefix). Gonka is 10^9 (n-prefix).
 */
export const GONKA_DECIMALS = 9;
export const GONKA_BASE_DENOM = 'ngonka';
export const GONKA_DISPLAY_DENOM = 'gonka';
export const GONKA_SYMBOL = 'GNK';
//# sourceMappingURL=config.js.map